module.exports = __webpack_public_path__ + "img/fedex-logo.434a7144.svg";